import { render, staticRenderFns } from "./uploadResume.vue?vue&type=template&id=c26d6eae&scoped=true"
import script from "./uploadResume.vue?vue&type=script&lang=js"
export * from "./uploadResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26d6eae",
  null
  
)

export default component.exports